/* Button style factory and the three preset variants used app-wide.
   Pure code-motion from src/App.jsx (Phase 2 group 3). */

import { brand } from './brand.js';

export const btn = (overrides = {}) => ({
  padding: "8px 16px",
  fontSize: "13px",
  fontWeight: "600",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
  fontFamily: brand.font,
  transition: "background-color 0.15s ease",
  ...overrides,
});

export const btnPrimary = btn({ color: brand.white, backgroundColor: brand.prussianBlue });
export const btnSecondary = btn({ color: brand.textSecondary, backgroundColor: brand.porcelainBlue, border: `1px solid ${brand.borderLight}` });
export const btnDanger = btn({ color: brand.white, backgroundColor: brand.dangerRed, fontSize: "12px", padding: "5px 12px" });
